import { render, staticRenderFns } from "./NantunSchool.vue?vue&type=template&id=1d5e8162&"
import script from "./NantunSchool.vue?vue&type=script&lang=js&"
export * from "./NantunSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports